import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {first} from 'rxjs/operators';
import {CategoryService} from '../../../services/category.service';
import {ToastrService} from 'ngx-toastr';
import {ResourceService} from '../../../services/resource.service';
import {BrandService} from "../../../services/brand.service";

@Component({
    selector: 'app-category-add-edit',
    templateUrl: './category-add-edit.component.html',
    styleUrls: ['./category-add-edit.component.scss']
})
export class CategoryAddEditComponent implements OnInit {

    form: FormGroup;
    submitted = false;
    loading = false;
    category: any = {};
    id: number;
    pathFile1 = 'Elegir Foto';
    pathFile2 = 'Elegir Foto';
    pathFile3 = 'Elegir Foto';
    brands: any = [];
    select_brand: any;
    brands_data: any = [];

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private categoryService: CategoryService,
        private resourceService: ResourceService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private brandService: BrandService,
    ) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            photo: [''],
            photo_2: [''],
            photo_3: [''],
            title_seo: ['', Validators.required],
            description_seo: ['', Validators.required],
            keywords: ['', Validators.required],
            status: ['1', Validators.required],
            principal: ['1', Validators.required],
            brands: '',
        });

        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.spinner.show();
            this.categoryService.getById(this.id).pipe(first()).subscribe(response => {
                this.spinner.hide();
                this.form.patchValue(response.data);
                this.category = response.data;
                response.brands.forEach((data, index) => {
                    if (data.brand) {
                        this.brands_data.push(data.brand);
                    }
                })
            }, error => {
                this.spinner.hide();
                this.router.navigate(['']);
            });
        }

        this.getBrands();
    }

    getBrands() {
        this.brandService.getAll().subscribe(response => {
            this.brands = response.data;
        }, error => {
            this.toastrService.error(error, 'Error');
        });
    }

    onSelectBrand(e) {
        this.select_brand = e.target.value;
    }

    addBrand() {
        if (this.select_brand) {
            this.brands.forEach(item => {
                if (item.id == this.select_brand) {
                    let duplicate = this.brands_data.filter(data => data.id == this.select_brand);
                    if (duplicate.length < 1) {
                        this.brands_data.push(item);
                    }
                }
            });
        }
    }

    deleteBrand(item: any){
        this.brands_data.forEach((data, index) => {
            if (data.id == item) {
                this.brands_data.splice(index, 1);
            }
        })
    }

    get f() {
        return this.form.controls;
    }

    sendForm(): void {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        this.loading = true;
        this.form.controls.brands.setValue(this.brands_data);
        let category: any = this.form.value;
        if (this.id != null) {
            category.id = this.id;
            this.categoryService.update(category)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/categories']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.categoryService.store(category)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/categories']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }

    onSelectFile(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'categories');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.photo.setValue(response.file);
                this.pathFile1 = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }

    onSelectFileTwo(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'categories');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.photo_2.setValue(response.file);
                this.pathFile2 = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }

    onSelectFileThree(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'categories');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.photo_3.setValue(response.file);
                this.pathFile3 = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }
}
